export default "__VITE_ASSET__CZxYmV3Z__"